module.exports = __webpack_public_path__ + "static/media/MapPin.fa65153c.svg";